import api from './api';

const BASE = '/platform/errors';

const unwrap = (response) => response?.data;

export const fetchPlatformErrors = async (params = {}) => unwrap(await api.get(BASE, { params }));

export const forgetPlatformFailedJob = async (id) =>
  unwrap(await api.delete(`${BASE}/failed-jobs/${encodeURIComponent(id)}`));

const platformErrorsApi = {
  fetchPlatformErrors,
  forgetPlatformFailedJob,
};

export default platformErrorsApi;
